class DataTypeDto {
    Type: number;  // Assuming Type is a number representing some kind of field type identifier
    IsMultiple: boolean;
    Label: string;

    constructor(
        type: number,
        isMultiple: boolean,
        label: string
    ) {
        this.Type = type;
        this.IsMultiple = isMultiple;
        this.Label = label;
    }
}

export default DataTypeDto;
